import React from 'react'
import { generateBgImage } from '/js/util'
import OpenArrow from '/img/svg/open-arrow'
import cx from 'classnames'

const DEFAULT_CLASSES =
  'story-card w-full overflow-hidden bg-white flex relative flex-col rounded-tr-wide rounded-bl tracking-wide relative bg-cover bg-center'
const CHARACTER_LIMIT = 170

class StoryCard extends React.Component {
  constructor(props) {
    super(props)

    const { content, sectionTitle } = this.props
    this.titleText = content.title || sectionTitle
  }
  generateClasses() {
    const { hiddenSections, sectionTitle } = this.props
    const { expandableContent, imageKey, hideAsCard } = this.props.content

    return cx(DEFAULT_CLASSES, {
      'hover:-translate-y-5 hover:shadow-outer group': expandableContent,
      'justify-end': imageKey,
      'scale-0 opacity-0 max-w-0 max-h-0 min-h-0 md:min-h-320 cursor-none m-0 p-0 transition-vslow': hiddenSections.includes(
        sectionTitle
      ),
      'scale-100 opacity-100 max-w-256 max-h-320 min-h-320 p-32 py-35 mb-32 md:mx-16 transition-fast': !hiddenSections.includes(
        sectionTitle
      ),
      hidden: hideAsCard
    })
  }

  generatePreview() {
    const { content } = this.props
    const previewText = content.preview
    const firstText = !!content.expandableContent.find(item => item['text'])
      ? Object.values(content.expandableContent.find(item => item['text']))[0]
      : null
    const isTextPresent = !!previewText || !!firstText

    if (!isTextPresent) {
      return null
    }

    const selectedText = !!previewText ? previewText : firstText

    return selectedText.length > CHARACTER_LIMIT
      ? selectedText.substring(0, CHARACTER_LIMIT) + '…'
      : selectedText
  }

  renderButton() {
    const { expandableContent } = this.props.content

    if (!expandableContent) {
      return null
    }

    return (
      <button
        data-track-gtm={`Pillar|Card|${this.titleText}`}
        className="cursor-pointer absolute transparent inset-0 w-full h-full"
        onClick={this.props.openHandler}
      >
        <span className="screenreader">Learn more about {this.titleText}</span>
      </button>
    )
  }

  renderBgImage() {
    const { imageKey } = this.props.content

    if (!imageKey) {
      return null
    }

    return generateBgImage(imageKey)
  }

  renderIndicator() {
    const { hiddenSections, sectionTitle } = this.props
    const { theme } = this.props
    const { expandableContent } = this.props.content
    const arrowColor =
      theme.bgColor === 'bg-danaher-blue' ? 'text-white' : 'text-jet-black'
    const indicatorColor = cx('transition-fast', {
      'bg-transparent': hiddenSections.includes(sectionTitle),
      [theme.bgColor]: !hiddenSections.includes(sectionTitle)
    })

    if (!expandableContent) {
      return null
    }

    return (
      <div
        data-label="story-card-indicator"
        className="absolute right-0 top-0 w-100 h-100 rounded-tr overflow-hidden z-5"
      >
        <div
          className={`w-full h-full ${indicatorColor} transition-fast rotate-45 -mt-50 ml-50`}
        ></div>
        <div className={`absolute top-10 right-10 w-25 h-25 ${arrowColor}`}>
          <OpenArrow />
        </div>
      </div>
    )
  }

  renderContent() {
    const { hiddenSections, theme, sectionTitle } = this.props

    return (
      <div
        className={cx('transition-fast', {
          'opacity-0 scale-0': hiddenSections.includes(sectionTitle),
          'opacity-1 scale-100': !hiddenSections.includes(sectionTitle)
        })}
      >
        <h3
          className={`font-condensed font-14 uppercase mb-10 group-hover:-translate-y-5 transition-fast ${theme.textColor}`}
          dangerouslySetInnerHTML={{ __html: this.titleText }}
        />
        <p
          className="text-16 group-hover:-translate-y-5 transition-fast"
          dangerouslySetInnerHTML={{ __html: this.generatePreview() }}
        ></p>
      </div>
    )
  }

  render() {
    return (
      <div
        data-label="story-card"
        className={this.generateClasses()}
        style={this.renderBgImage()}
      >
        {this.renderIndicator()}
        <div className="bg-white opacity-85 absolute inset-0 z-0 rounded-tr-wide"></div>
        {this.renderContent()}
        {this.renderButton()}
      </div>
    )
  }
}

export default StoryCard
